var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.organization.name)?_c('h3',{staticClass:"title-20px mb-6"},[_vm._v(_vm._s(_vm.organization.name))]):_vm._e(),_c('e-tabs',{attrs:{"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }